(function ($) {
  'use strict';

  // If accordions haven't been initialised yet, add click listener
  var $pDescTarget = $('.panel-description:not(.panel-description--template) .panel-description__toggle');
  if (!$pDescTarget.hasClass('initialised')) {
    $('.panel-description:not(.panel-description--template) .panel-description__toggle').click(function () {
      var $accordionToggle = $(this).closest('.panel-description__title'),
        $accordionText = $accordionToggle.siblings('.panel-description__list');

      if ($accordionToggle.hasClass('active')) {
        $accordionToggle.removeClass('active');
        $accordionText.slideUp(300, function () {
          $accordionText.removeClass('active').removeAttr('style');
        });
      } else {
        $accordionToggle.addClass('active');
        $accordionText.slideDown(300, function () {
          $accordionText.addClass('active').removeAttr('style');
        });
      }

      return false;
    });

    // Prevent accordion from being initialised from other functions such as saved courses
    $pDescTarget.addClass('initialised');

    // Prevent focus on click
    $pDescTarget.on('mousedown click', function (e) {
      e.preventDefault();
      $(e.target).blur();
    });
  }
}(jQuery));